import { beginSearchUpdate, resolveListingUpdate } from './standard-listing-events.js';

const READY_EVENT = 'pttek:standard-events-ready';

export const dispatchSearchResults = (main, url = new URL(window.location.href)) => {
  if (main?.dataset.template !== 'search') return null;
  const count = Number(main.dataset.searchResultsCount);
  if (main.dataset.searchResultsCount === undefined || !Number.isFinite(count)) return null;
  const update = beginSearchUpdate(main, url);
  resolveListingUpdate(update, count);
  return update;
};

export const installRenderedSearchDispatch = (options = {}) => {
  const documentRef = options.documentRef || document;
  const windowRef = options.windowRef || window;
  const setTimer = options.setTimer || globalThis.setTimeout;
  const clearTimer = options.clearTimer || globalThis.clearTimeout;
  const maxRetries = options.maxRetries ?? 20;
  const retryDelay = options.retryDelay ?? 50;
  let retries = 0;
  let timer;
  let dispatched = false;

  const cleanup = () => {
    windowRef.removeEventListener?.(READY_EVENT, attempt);
    documentRef.removeEventListener?.('DOMContentLoaded', attempt);
    if (timer !== undefined) clearTimer(timer);
  };
  const attempt = () => {
    if (dispatched || documentRef.readyState === 'loading') return;
    if (!windowRef.pttekStandardEventsReady && !windowRef.StandardEvents) {
      if (retries >= maxRetries) return cleanup();
      retries += 1;
      timer = setTimer(attempt, retryDelay);
      return;
    }
    dispatched = true;
    cleanup();
    dispatchSearchResults(
      documentRef.querySelector('main[data-template="search"]'),
      new URL(windowRef.location.href)
    );
  };

  windowRef.addEventListener?.(READY_EVENT, attempt);
  if (documentRef.readyState === 'loading') documentRef.addEventListener('DOMContentLoaded', attempt, { once: true });
  else attempt();
  return cleanup;
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  installRenderedSearchDispatch();
}
